"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardName_1 = require("@/common/cards/CardName");
const PlayerResource_vue_1 = require("@/client/components/overview/PlayerResource.vue");
const Resource_1 = require("@/common/Resource");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PlayerResources',
    props: {
        player: {
            type: Object,
            required: true,
        },
    },
    computed: {
        Resource() {
            return Resource_1.Resource;
        },
        canUseHeatAsMegaCredits() {
            return this.player.tableau.some((card) => card.name === CardName_1.CardName.HELION);
        },
    },
    components: {
        'player-resource': PlayerResource_vue_1.default,
    },
});
